import { render } from "./AboutBlock.vue?vue&type=template&id=9c94930e&scoped=true"
import script from "./AboutBlock.vue?vue&type=script&lang=js"
export * from "./AboutBlock.vue?vue&type=script&lang=js"

import "./AboutBlock.vue?vue&type=style&index=0&id=9c94930e&scoped=true&lang=css"

import exportComponent from "/home/vrushaket@rhythm.local/vrushaket/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c94930e"]])

export default __exports__